import { CartProductCode, PriceCartItem } from '@ace-clublabs/common-membership-api-types';
import { useGlobalState } from '../../../../state/state';
import { ManageMembershipPriceCartItem } from '../ManageMembershipPriceCartItem';

export const SalesTaxPriceCartItem = () => {
  const [priceCart] = useGlobalState('priceCart');

  const salesTax = priceCart.salesTax;
  const salesTaxPriceCartItem: PriceCartItem = {
    id: 'sales-tax',
    code: CartProductCode.SALESTAX,
    description: 'Sales tax',
    price: salesTax || 0,
    discount: 0,
    discountedPrice: salesTax,
  };

  return salesTax ? (
    <ManageMembershipPriceCartItem
      key={salesTaxPriceCartItem.code}
      type="description"
      subtitle=""
      className="sales-tax-price-item"
      description={salesTaxPriceCartItem?.description}
      price={salesTaxPriceCartItem?.price}
    />
  ) : (
    <></>
  );
};
